<template>
  <div class="container">
    <div class="title">订单详情</div>
    <div class="header">
      <div class="status_text">{{ statusText(orderData.status) }}</div>
      <div class="see_logistics" v-if="orderData.status!=1&&orderData.status!=6" @click="seeLogistics">查看物流</div>
    </div>
    <div class="content">
      <div class="user_info_box content_box">
        <div class="user_item">
          <div class="user_info_title">下单用户</div>
          <div class="user_info">
            <img :src="orderData.userAvatar" alt="" />
            <div class="user_info_text">
              <div>{{ orderData.userNickName }}</div>
              <span>{{ orderData.userPhone }}</span>
            </div>
          </div>
        </div>
        <div class="user_item">
          <div class="user_info_title">归属工作室</div>
          <div class="user_info">
            <img :src="orderData.studioAvatar" alt="" />
            <div class="user_info_text">
              <div>{{ orderData.studioName }}</div>
              <span>{{ orderData.studioPhone }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="user_address_box content_box">
        <div class="user_address_top">
          {{ orderData.receiverName }} {{ orderData.receiverMobile }}
        </div>
        <div class="user_address_bottom">
          {{ orderData.receiverProvince }}{{ orderData.receiverCity
          }}{{ orderData.receiverArea }}
        </div>
      </div>
      <div class="list">
        <div class="content_" v-for="(v, index) in orderData.orderGoodsBrandsVO" :key="index">
          <div class="top_bp">
            <div class="row">
              <img class="logo_img" :src="v.brandsLogo" mode="" />
              <div style="font-weight: 700; margin-right: 10px">
                {{ v.brandsName }}
              </div>
            </div>
          </div>
          <div v-for="(item, index) in v.orderGoods" :key="index" style="overflow: hidden">
            <div class="commodity">
              <img :src="item.thumPic" />
              <div class="goods_info_box">
                <div class="goods_info">
                  <div class="goods_info_l">
                    <div class="row row-between">
                      <div class="title_t">
                        <span style="line-height: 1.2; word-break: break-all">{{
                          item.name
                        }}</span>
                      </div>
                    </div>
                    <div @tap="productDetail(item)" class="row row-between">
                      <div>
                        <div class="guige" v-if="item.skuProperties">
                          <span v-for="(items, index) in JSON.parse(
                            item.skuProperties
                          )" :key="index">{{ items.value
                            }}<span class="m-l-10 m-r-10" v-if="
                              JSON.parse(item.skuProperties).length - 1 !=
                              index
                            ">
                              ;
                            </span>
                          </span>
                        </div>
                        <div class="guige" v-else>默认规格</div>
                      </div>
                    </div>
                    <div class="goods_info_r row row-between">
                      <div class="">
                        ￥<span>{{ item.price }}</span>
                      </div>
                      <div class="num">× {{ item.count }}</div>
                    </div>
                  </div>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="order_money_box content_box">
        <div class="item_box">
          <div class="item_label">商品总额</div>
          <div class="item_value">￥{{ Number(orderData.goodsMoney) }}</div>
        </div>
        <div class="item_box">
          <div class="item_label">运费</div>
          <div class="item_value">￥{{ orderData.expressFee }}</div>
        </div>
        <div class="item_box">
          <div class="item_label"></div>
          <div class="item_value">
            实付款：
            <span>￥{{ totalMoney }}</span>
          </div>
        </div>
      </div>
      <div class="content_box">
        <div class="item_box">
          <div class="item_label">订单编号</div>
          <div class="item_value">{{ orderData.id }}<span class="copy" @click="copy(orderData.id)">复制</span></div>
        </div>
      </div>
    </div>
    <div class="foot">
      <van-button class="button" @click="goBlack">返回</van-button>
    </div>
  </div>
</template>
<script>
import { getGoodsOrderDetail } from "@/api/home.js";
export default {
  name: "productDetail",
  data() {
    return {
      orderData: {},
      totalMoney: "",
    };
  },
  created() {
    this.getGoodsOrderDetail(this.$route.query.id);
  },
  methods: {
    statusText(status) {
      let text = "";
      if (status == 1) {
        text = "待发货";
      } else if (status == 2) {
        text = "待收货";
      } else if (status == 3) {
        text = "已完成";
      } else if (status == 6) {
        text = "已退款";
      }
      return text;
    },
    getGoodsOrderDetail(orderId) {
      getGoodsOrderDetail(orderId).then((res) => {
        console.log(res);
        if (res.code == 0) {
          this.orderData = res.data;
          this.totalMoney = (
            Number(this.orderData.totalMoney) +
            Number(this.orderData.paymentInfoVO.tax)
          ).toFixed(2);
        }
      });
    },
    goBlack() {
      this.$router.back();
    },
    seeLogistics() {
      this.$router.push({
        path: '/teamOrders/logistics/index',
        query: {
          askNo: this.orderData.id,
        }
      })
    },
    copy(value) {
      const input = document.createElement("input");
      input.value = value;
      document.body.appendChild(input);
      input.select();
      document.execCommand("Copy");
      document.body.removeChild(input);
      this.$toast("复制成功");
    }
  },


};
</script>
<style scoped lang="scss">
.container {
  padding-top: 40px;
  padding-bottom: 50px;
  height: 100%;
  box-sizing: border-box;
}

.title {
  position: fixed;
  top: 0;
  z-index: 99;
  background: #fff;
  width: 100%;
  line-height: 40px;
  text-align: center;
}

.header {
  width: 100%;
  padding: 24px 16px 41px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  box-sizing: border-box;
  background: rgb(25, 137, 250);
  font-size: 18px;

  .status_text {}

  .see_logistics {
    font-size: 16px;
    padding: 4px;
    border: 1px solid #fff;
  }
}

.content {
  .content_box {
    width: 95%;
    margin: 0 auto;
    margin-bottom: 16px;
    padding: 16px;
    background: #fff;
    border-radius: 6px;
    box-sizing: border-box;

    .item_box {
      margin-bottom: 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      line-height: 1;

      .item_label {
        color: #7c807f;
        font-size: 14px;
      }

      .item_value {
        display: flex;
        align-items: center;
        font-size: 15px;
        font-weight: 700;

        span {
          color: rgb(192, 142, 11);
        }

        .copy {
          margin-left: 8px;
          padding: 4px;
          border-radius: 4px;
          color: #fff;
          display: inline-block;
          background: rgb(25, 137, 250);
          font-size: 14px;
          font-weight: normal;
        }
      }

    }

    .item_box:last-child {
      margin-bottom: 0;
    }
  }

  .user_info_box {
    margin-top: -16px;
    display: flex;
    justify-content: space-between;

    .user_item {
      .user_info_title {
        margin-bottom: 8px;
        font-size: 16px;
        color: #261b11;
        font-weight: 700;
      }

      .user_info {
        display: flex;
        align-items: center;

        img {
          width: 24px;
          height: 24px;
          margin-right: 8px;
          border-radius: 50%;
        }

        .user_info_text {
          display: flex;
          flex-direction: column;

          div {
            font-size: 16px;
          }

          span {
            font-size: 14px;
          }
        }
      }
    }
  }

  .user_address_box {
    .user_address_top {
      font-size: 16px;
      font-weight: 700;
      margin-bottom: 8px;
    }

    .user_address_bottom {
      font-size: 14px;
    }
  }

  .order_money_box {
    .item_box {
      margin-bottom: 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      line-height: 1;

      .item_label {
        color: #7c807f;
        font-size: 14px;
      }

      .item_value {
        font-size: 15px;
        font-weight: 700;

        span {
          color: rgb(192, 142, 11);
        }
      }
    }
  }
}

.list {
  .content_ {
    border-radius: 6px;
    margin: 0 16px;
    background: #ffffff;
    padding-bottom: 16px;
    overflow: hidden;
    margin-bottom: 16px;
  }

  .top_bp {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 20px;
    padding: 12px 0 4px 0;
    line-height: 1;
    font-size: 16px;

    .logo_img {
      width: 40px;
      height: 40px;
      margin-right: 4px;
    }
  }

  .commodity {
    display: flex;
    margin-top: 16px;
  }

  .commodity img {
    width: 80px;
    height: 80px;
    margin: 0 12px 0 16px;
    border-radius: 6px;
  }

  .goods_info_box {
    width: calc(100% - 80px);
  }
  .goods_info_l{
    width: 100%;
  }
  .goods_info {
    width: 100%;
    display: flex;
    justify-content: space-between;
    .goods_info_r {
      padding-right: 16px;
      margin-top: 10px;
      box-sizing: border-box;
    }
  }

  .title_t {
    flex-shrink: 0;
    width: 130px;
    margin-bottom: 8px;
    line-height: 1;
  }

  .guige {
    color: #7c807f;
    font-size: 15px;
  }
}

.break-word {
  // 针对符号、数字多行超出的问题
  word-break: break-all;
  word-wrap: break-word;
}

.row {
  display: flex;
  flex-direction: row; // 默认值（主轴为水平方向，起点在左端）。主轴的方向。
  align-items: center;
}

.row-between {
  justify-content: space-between;
}

.foot {
  width: 95%;
  position: fixed;
  left: 2.5%;
  bottom: 0;

  .button {
    width: 100%;
    border-radius: 6px;
    background: rgb(25, 137, 250);
    color: #fff;
  }
}
</style>
